<footer>
	<div class="footer_top">
		  <div class="container">
    	<div class="row">
			<div class="col_ft col-12 col-sm-6 col-md-3">
					<h5>About Us</h5>
				    <div class="logo_ft_row">
						<div class="logo_ft"><img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/ft_logo.png"></div>
					<div class="logo_cont">
						<p></p>
					</div>
				</div>
		    </div>
		    <div class="col_ft col-12 col-sm-6 col-md-3">
					<h5>Contact Info</h5>
				    <span class="adr_span"><img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/nav.svg"><span>9601 Gayton Rd Ste 207, Henrico, VA 23238</span></span>
				    <span class="adr_span"><img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/phone-1.svg"><span><a href="tel:(804) 709-1954">(804) 709-1954</a></span></span>
				    <span class="adr_span"><img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/Email.svg"><span><a href="mailto:info@dudleyresources.com">info&#64;dudleyresources.com</a></span></span>
		   </div>
		    <div class="col_ft col-12 col-sm-6 col-md-3">
					<h5>Recent News</h5>
				<div class="blog_list_ft">



						<a href="https://auctionprosrva.com/auction/2024/09/01/how-can-i-tell-if-an-auction-is-legitimate//" class="blog_ft_row">
							<div class="blog_img_ft">
							    							        <img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/legitimate.png">
							    							</div>
							<div class="blog_cont_ft">
								<h6>How can I tell if an auction is legitimate?</h6>
								<span class="date">Sep 01 2024</span>
							</div>
				    	</a>


						<a href="https://auctionprosrva.com/auction/2024/06/13/10-reasons-to-sell-via-the-auction-method-of-marketing/" class="blog_ft_row">
							<div class="blog_img_ft">
							    							        <img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/auction-method.png">
							    							</div>
							<div class="blog_cont_ft">
								<h6>10 Reasons to sell via the Auction Method of Marketing</h6>
								<span class="date">Jun 13 2024</span>
							</div>
				    	</a>


						<a href="https://auctionprosrva.com/auction/2024/03/21/what-is-the-aare-and-why-is-it-important/" class="blog_ft_row">
							<div class="blog_img_ft">
							    							        <img src="https://auctionprosrva.com/auction/wp-content/uploads/2024/03/AARE.png">
							    							</div>
							<div class="blog_cont_ft">
								<h6>What is the AARE and why is it important?</h6>
								<span class="date">Mar 21 2024</span>
							</div>
				    	</a>
				    	   				</div>
		</div>
	  	   <div class="col_ft col-12 col-sm-6 col-md-3">
			   <h5>Work With Us</h5>
			   <p>40+ years of national auction experience right next door in Richmond, VA.  <a href="https://auctionprosrva.com/auction/contact/" target="_blank" rel="noopener noreferrer"> Contact Us today! </a></p>
		   </div>
	  </div>
		  </div>
	</div>
		  <div class="footer_bottom">
			  <div class="container">
				  	<div class="row">
							<div class="align-items-baseline col-12 d-flex justify-content-between">
								<div class="d-flex gap-2">
								<a href="https://auctionprosrva.com/auction/contact/" target="_blank" rel="noopener noreferrer">Contact  </a> | <a href="https://auctionprosrva.com/auction/privacy-policy/" target="_blank" rel="noopener noreferrer">Terms of Use</a>
							</div>
							<span>Copyright © {{ currentYear }} Auction Pros RVA</span>
						</div>
						<!-- <div class="col-12 col-sm-6 ">
								<div class="social">
									<a target="_blank" href=""><img src="https://auctionprosrva.com/wp-content/uploads/2024/03/fb.svg"></a>
									<a target="_blank" href=""><img src="https://auctionprosrva.com/wp-content/uploads/2024/03/insta.svg"></a>
									<a target="_blank" href=""><img src="https://auctionprosrva.com/wp-content/uploads/2024/03/twit.svg"></a>

								</div>
						</div>	-->
				  </div>
			  </div>
		  </div>
  </footer>
